import React from 'react';
import { Linking, Pressable, StyleSheet, Text } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { FONTS } from '../config/fonts';
import { strings } from '../strings';
import type { Affiliation } from '../types/affiliation';

type AffiliationBadgeProps = {
  affiliation: Affiliation | null;
};

const AffiliationBadge = ({ affiliation }: AffiliationBadgeProps) => {
  const insets = useSafeAreaInsets();

  if (!affiliation) {
    return null;
  }

  const handlePress = () => {
    Linking.openURL(affiliation.url).catch(() => {
      console.error('Failed to open affiliation URL', affiliation.url);
    });
  };

  return (
    <Pressable
      accessibilityHint={strings.opensInBrowser}
      accessibilityLabel={affiliation.text}
      accessibilityRole="link"
      onPress={handlePress}
      style={({ pressed }) => [
        styles.badge,
        // Align with CurrentLocationButton, above the bottom SearchBar.
        { bottom: insets.bottom + 78 },
        pressed && styles.badgePressed,
      ]}
    >
      <Text style={styles.text}>{affiliation.text}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  badge: {
    direction: 'rtl',
    position: 'absolute',
    left: 16,
    alignSelf: 'flex-start',
    backgroundColor: '#ff3e3e',
    borderRadius: 24,
    paddingHorizontal: 16,
    paddingVertical: 12,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  badgePressed: {
    opacity: 0.8,
  },
  text: {
    fontFamily: FONTS.regular,
    fontSize: 14,
    color: '#fdfdfd',
  },
});

export default AffiliationBadge;